"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.cssAnchorName = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _csrf = require("@insided/shared/utils/csrf");

var _constants = require("../constants");

var _effects = require("../effects");

var _classnames = _interopRequireDefault(require("classnames"));

var _axios = _interopRequireDefault(require("axios"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var cssAnchorName = 'unfollow-user';
exports.cssAnchorName = cssAnchorName;

var unfollowUrl = function unfollowUrl(id) {
  return (0, _absoluteUrlRuntime.resolveUrl)("/network/unfollow?connectionid=".concat(id));
};

var UnfollowUser = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(UnfollowUser, _Component);

  var _super = _createSuper(UnfollowUser);

  function UnfollowUser() {
    var _this;

    (0, _classCallCheck2.default)(this, UnfollowUser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      isLoading: false,
      isRemoved: false
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleClick", /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(e) {
        var anchor, row;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                e.preventDefault();
                e.stopPropagation();

                if (!_this.state.isLoading) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return");

              case 4:
                _this.setState({
                  isLoading: true
                });

                _context.prev = 5;
                _context.next = 8;
                return _axios.default.post(unfollowUrl(_this.props.connectionId), new URLSearchParams((0, _csrf.withCsrf)()));

              case 8:
                (0, _effects.mutateCounter)(_constants.FOLLOWING_COUNTER_SELECTOR, -1);
                anchor = _this.base;
                row = anchor === null || anchor === void 0 ? void 0 : anchor.closest(_constants.FOLLOWING_ROW_SELECTOR);

                _this.setState({
                  isRemoved: true
                });

                if (row) (0, _effects.slideUpAndRemove)(row);
                _context.next = 18;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context["catch"](5);

                _this.setState({
                  isLoading: false
                });

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[5, 15]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    return _this;
  }

  (0, _createClass2.default)(UnfollowUser, [{
    key: "render",
    value: function render() {
      if (this.state.isRemoved) return null;
      var className = (0, _classnames.default)('btn--toggle', 'toggle-follow', 'is-follow', {
        'is-loading': this.state.isLoading
      });
      return (0, _preact.h)("a", {
        href: (0, _absoluteUrlRuntime.resolveUrl)(unfollowUrl(this.props.connectionId)),
        class: className,
        onClick: this.handleClick
      }, (0, _preact.h)(_phrase.default, {
        p: "Following",
        renderAsText: true
      }));
    }
  }]);
  return UnfollowUser;
}(_preact.Component);

exports.default = UnfollowUser;